<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("fnbWastage") }}
      </div>
      <router-link class="btn-blue" to="/fnb/fnb-wastage"
        >{{ $t("fnbWastage") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <form class="row">
        <!-- CINEMAS SELECTION -->
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  href="#"
                  @click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectcinema')" />
            </div>
            <p
              v-if="submitted && selectedCinema.length == 0"
              class="error_message"
            >
              Please Select Cinema.
            </p>
          </div>
        </div>

        <!-- SELECTED CONCESSION -->
        <!-- <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedConcession.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $t('concession') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedConcession" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in concessionLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectConcessionLevel(Item)"
                >{{ Item.cl_name }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectconcession')" />
            </div>
            <p
              v-if="submitted && selectedConcession.length == 0"
              class="error_message"
            >Please Select Concession.</p>
          </div>
        </div>-->

        <!-- STORE LEVEL -->
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedStoreLevel.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedStoreLevel"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in storeManagementsLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectMainStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectconcession')" />
            </div>
            <p
              v-if="submitted && selectedStoreLevel.length == 0"
              class="error_message"
            >
              Please Select Store Level.
            </p>
          </div>
        </div>

        <div v-if="finalStoreLevel.length > 0" class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedFinalStore.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedFinalStore"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in finalStoreLevel"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectconcession')" />
            </div>
            <p
              v-if="submitted && selectedFinalStore.length == 0"
              class="error_message"
            >
              Please Select Store Level.
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedRawMaterial.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("rawmaterials", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedRawMaterial"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Raw Material"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchRawMaterial()"
                    v-on:keydown="onSearchRawMaterial()"
                    v-on:search="onSearchRawMaterial()"
                    v-model="searchRawMaterial"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in rawMaterials"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectRawMaterial(Item)"
                  >{{ Item.rm_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_rawmaterials')" />
            </div>
            <p
              v-if="submitted && selectedRawMaterial.length == 0"
              class="error_message"
            >
              Please Select Raw Material.
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedUoM.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("unitofmeasurement", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedUoM"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in UoMList"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectUom(Item)"
                  >{{ Item.uom_unit }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_selectunitofmeasurements')" />
            </div>
            <p
              v-if="submitted && selectedUoM.length == 0"
              class="error_message"
            >
              Please Select Unit of Measurement.
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <!-- <label
              :class="selectedQuantity.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('quantity', 2) }}</label>-->
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="String(selectedQuantity)" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(Item,ItemIndex) in 20"
                  :key="ItemIndex"
                  href="#"
                  @click="selectedQuantity = String(Item);fnb_wastage.fw_quantity=Item"
                >{{ Item }}</b-dropdown-item>
              </b-dropdown>-->
              <!-- <b-input-group> -->
              <div class="input-material">
                <input
                  v-model="fnb_wastage.fw_quantity"
                  style="
                    height: 40px;
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;
                  "
                  type="text"
                  placeholder="."
                  name="wastage_qty"
                  id="wastage_qty"
                  v-validate="'required|numeric'"
                  v-on:keyup="calculatemaxqty($event.target.value)"
                />
              </div>
              <label
                :class="
                  fnb_wastage.fw_quantity &&
                  String(fnb_wastage.fw_quantity).length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("quantity") }}</label
              >
              <!-- v-on:keyup="CalculateSelectedRawMaterial($event.target.value,vendorIndex)" -->

              <!-- <template v-slot:append>
                    <b-dropdown variant="dropdown-curve" class="w-100">
                      <b-dropdown-item
                        v-for="(loop , key) in 20"
                        :key="key"
                        v-on:click="onSelectQuantity(loop)"
                      >{{loop}}</b-dropdown-item>
                    </b-dropdown>
                  </template>
              </b-input-group>-->
              <Tooltip :title="$t('fnbwastage_selectquantity')" />
            </div>
            <p
              v-if="submitted && errors.has('wastage_qty')"
              class="error_message"
            >
              {{ errors.first("wastage_qty") }}
            </p>
          </div>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $t('select') }} {{ $tc('quantity', 2) }}</label>
          </div>
          <div class>
            <b-dropdown :text="selectedQuantity" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Item,ItemIndex) in 20"
                :key="ItemIndex"
                href="#"
                @click="selectedQuantity = Item;fnb_wastage.fw_quantity=Item"
              >{{ Item }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <p
            v-if="submitted && selectedQuantity == 'Select Quantity'"
            class="error_message"
          >Please Select Quantity.</p>
        </div>-->

        <div class="col-md-3 mb-4 d-none">
          <div class="dropdown-curve-container">
            <label
              :class="selectedAccountableUser.length > 0 ? 'shift-up' : ''"
              >{{ $t("accountableuser") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedAccountableUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUser()"
                    v-on:keydown="onSearchUser()"
                    v-on:search="onSearchUser()"
                    v-model="searchUser"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in accountableUserListFiltered"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectAccountableUser(Item)"
                  >{{ Item.first_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_accountableuser')" />
            </div>
            <p
              v-if="submitted && selectedAccountableUser.length == 0"
              class="error_message"
            >
              Please Select Accountable User.
            </p>
          </div>
        </div>

        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedApprovedUser.length > 0 ? 'shift-up' : ''">{{
              $t("approvedby")
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedApprovedUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchApprovedBy()"
                    v-on:keydown="onSearchApprovedBy()"
                    v-on:search="onSearchApprovedBy()"
                    v-model="searchApprovedBy"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in userListFiltered"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectApprovedByUser(Item)"
                  >{{ Item.first_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('fnbwastage_approvedby')" />
            </div>
            <p
              v-if="submitted && selectedApprovedUser.length == 0"
              class="error_message"
            >
              Please Select Approved By.
            </p>
          </div>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $t('approvedby') }}</label>
          </div>
          <div class>
            <b-dropdown :text="selectedApprovedUser" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Item,ItemIndex) in users"
                :key="ItemIndex"
                href="#"
                @click="onSelectApprovedByUser(Item)"
              >{{ Item.first_name }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <p
            v-if="submitted && selectedApprovedUser == 'Approved By'"
            class="error_message"
          >Please Select Approved By.</p>
        </div>-->

        <!-- AMOUNT -->
        <div class="col-md-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_wastage.fw_reason"
                name="remark"
                id="remark"
                v-validate="'required'"
              />
              <label>{{ $tc("remark", 2) }}</label>
            </div>
            <Tooltip :title="$t('fnbwastage_reasons')" />
          </div>
          <p v-if="submitted && errors.has('remark')" class="error_message">
            {{ errors.first("remark") }}
          </p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <label>{{ $tc('reason', 2) }}</label>
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="."
                type="text"
                v-model="fnb_wastage.fw_reason"
                name="reason"
                id="reason"
                v-validate="'required|alpha_spaces'"
              />
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
          <p
            v-if="submitted && errors.has('reason')"
            class="error_message"
          >{{ errors.first('reason') }}</p>
        </div>-->

        <!-- TOTAL AMOUNT -->
        <div class="col-md-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_wastage.fw_fine_amount"
                name="fineamount"
                id="fineamount"
                v-validate="'required|decimal|max:6'"
              />
              <label>{{ $tc("totalamount", 2) }}</label>
            </div>
            <Tooltip :title="$t('fnbwastage_fireamount')" />
          </div>
          <p v-if="submitted && errors.has('fineamount')" class="error_message">
            {{ errors.first("fineamount") }}
          </p>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <label>{{ $tc('fineamount', 2) }}</label>
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="."
                type="text"
                v-model="fnb_wastage.fw_fine_amount"
                name="fineamount"
                id="fineamount"
                v-validate="'required|numeric'"
              />
            </div>
            <Tooltip :title="$t('tooltip')" />
          </div>
          <p
            v-if="submitted && errors.has('fineamount')"
            class="error_message"
          >{{ errors.first('fineamount') }}</p>
        </div>-->

        <!-- FNB PRICE FROM DATE -->

        <div class="col-md-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="fnb_wastage.fw_date"
                  v-on:click="cleardoj()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fnb_wastage.fw_date"
                  name="fromd"
                  id="fromd"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="
                    typeof fnb_wastage.fw_date === 'object' ? 'active' : ''
                  "
                  >From Date</label
                >
              </div>
            </div>
            <Tooltip :title="$t('fnbwastage_fromdate')" />
          </div>
          <p v-if="submitted && errors.has('fromd')" class="error_message">
            {{ errors.first("fromd") }}
          </p>
        </div>

        <!-- IS ACTIVE -->
        <div class="col-md-4 mb-4">
          <label>{{ $t("active") }}</label>
          <div class="d-flex align-items-center">
            <label class="ios-switch ml-2">
              <input
                v-model="fnb_wastage.fw_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/fnb-wastage"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService.js";
  import MasterService from "@/services/MasterService.js";

  export default {
    data() {
      return {
        usersCopy: [],
        searchApprovedBy: "",
        accountableUsersCopy: [],
        searchUser: "",
        rawMaterialsCopy: [],
        searchRawMaterial: "",
        cinemasCopy: [],
        searchCinema: "",
        isRoleID: true,
        submitted: false,
        fnb_wastage: {
          cinema_id: "",
          concession_level_id: "",
          sm_id: "",
          rm_id: "",
          fw_quantity: "",
          uom_id: "",
          fw_reason: "",
          // fw_accountable_user_id: "",
          fw_is_approved: "",
          fw_approved_by: "",
          fw_fine_amount: "",
          fw_date: "",
          fw_is_active: true,
          fw_is_approved: true,
          fw_id: "",
        },
        cinemas: [],
        concessionLevels: [],
        finalStoreLevel: [],
        max_qty: null,
        storeManagementsLevels: [],
        selectedFinalStore: "",
        rawMaterials: [],
        UoMList: [],
        accountableUsers: [],
        users: [],
        selectedCinema: "Select Cinema",
        selectedConcession: "Select Concession",
        selectedStoreLevel: "Select Store",
        selectedRawMaterial: "Select Raw Material",
        selectedQuantity: "Select Quantity",
        selectedUoM: "Select UoM",
        selectedAccountableUser: "Select Accountable User",
        selectedApprovedUser: "Approved By",
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemas(obj);
      this.fnb_wastage.fw_id = this.$route.query.fw_id;
    },
    mounted() {
      this.getFnbWastageDetails();
      // this.getCinemas();
      // this.getRawMaterials();
      // this.getUomList();
      // this.getUser();
    },
    computed: {
      userListFiltered() {
        let arr = [];
        if (this.fnb_wastage.cinema_id) {
          arr = this.users.filter(
            (x) => x.cinema_id == this.fnb_wastage.cinema_id || !x.cinema_id
          );
        }
        return arr;
      },
      accountableUserListFiltered() {
        let arr = [];
        if (this.fnb_wastage.cinema_id) {
          arr = this.accountableUsers.filter(
            (x) => x.cinema_id == this.fnb_wastage.cinema_id || !x.cinema_id
          );
        }
        return arr;
      },
    },
    methods: {
      cleardoj() {
        this.fnb_wastage.fw_date = "";
      },
      onSearchApprovedBy: function() {
        if (this.searchApprovedBy && this.searchApprovedBy.length > 0) {
          this.users = this.usersCopy.filter((x) => {
            // let full_name = `${x.first_name} ${x.last_name}`
            if (
              x.first_name
                .toLowerCase()
                .includes(this.searchApprovedBy.toLowerCase())
              // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.users = this.usersCopy;
        }
      },
      onSearchUser: function() {
        if (this.searchUser && this.searchUser.length > 0) {
          this.accountableUsers = this.accountableUsersCopy.filter((x) => {
            // let full_name = `${x.first_name} ${x.last_name}`
            if (
              x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
              // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.accountableUsers = this.accountableUsersCopy;
        }
      },
      onSearchRawMaterial: function() {
        if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
          this.rawMaterials = this.rawMaterialsCopy.filter((x) => {
            if (
              x.rm_name
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.rawMaterials = this.rawMaterialsCopy;
        }
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.cinemas = this.cinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.cinemas = this.cinemasCopy;
        }
      },
      onSelectQuantity: function(params) {
        // this.selectedQuantity = params.toString();
        this.fnb_wastage.fw_quantity = params;
      },
      getFnbWastageDetails: function() {
        let payload = {
          tableName: "fnb_wastage",
          fw_id: this.fnb_wastage.fw_id,
        };
        // PosFnbService.GetFnbWastageDetails(payload)
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // console.log("data.Records :", data.Records);
              let obj = data.Records[0];
              this.fnb_wastage = obj;
              this.fnb_wastage.fw_date = new Date(obj.fw_date);
              // this.selectedQuantity = String(obj.fw_quantity);
              this.fnb_wastage.fw_quantity = obj.fw_quantity;
              this.setCinema(obj.cinema_id);
              // this.getConcessionLevels(obj.cinema_id, obj.concession_level_id);
              this.getStoreManagementLevel(obj.cinema_id, obj.sm_id);
              this.getRawMaterials(obj.rm_id, { sm_id: obj.sm_id });
              this.getRelatedUom(obj.rm_id);
              this.getUomList(obj.uom_id);
              this.getApprovedUser(obj.fw_approved_by);
              // this.getAccountableUser(obj.fw_accountable_user_id);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getUomList: function(uom_id) {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              data.Records.map((x) => {
                if (x.uom_id == uom_id) {
                  this.selectedUoM = x.uom_unit;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getApprovedUser: function(user_id) {
        let payload = {
          tableName: "users",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.users = data.Records.filter((x) =>
                ["1", "2", "3"].includes(String(x.role_id))
              );
              this.usersCopy = data.Records.filter((x) =>
                ["1", "2", "3"].includes(String(x.role_id))
              );

              this.accountableUsers = data.Records.filter((x) =>
                ["4", "8"].includes(String(x.role_id))
              );
              this.accountableUsersCopy = data.Records.filter((x) =>
                ["4", "8"].includes(String(x.role_id))
              );

              let userObj = this.accountableUsers.find(
                (x) => x.user_id == user_id
              );
              if (userObj) {
                this.onSelectAccountableUser(userObj);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getAccountableUser: function(user_id) {
        let payload = {
          tableName: "users",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.users = data.Records;
              this.usersCopy = data.Records;

              this.users.map((x) => {
                if (x.user_id == user_id) {
                  this.selectedAccountableUser = x.first_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterials: function(rm_id, store) {
        this.rawMaterials = [];
        this.rawMaterialsCopy = [];
        let payload = {
          sm_id: store.sm_id,
        };
        PosFnbService.GetStoreBasedQuantity(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterials = data.Records;
              this.rawMaterialsCopy = data.Records;
              this.rawMaterials.map((x) => {
                if (x.rm_id == rm_id) {
                  this.selectedRawMaterial = x.rm_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      setCinema: function(cinema_id) {
        // console.log("cinema_id :", cinema_id);
        // let payload = {
        //   tableName: "ms_cinemas"
        // };
        MasterService.GetCinemas({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.cinemas = data.Records;
              this.cinemas.map((x) => {
                if (String(x.cine_id) == String(cinema_id)) {
                  // this.selectedCinema = x.cine_name;
                  this.selectedCinema = x.cine_name;
                  this.fnb_wastage.cinema_id = x.cine_id;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getCinemas: function(cinema_id) {
        // console.log("cinema_id :", cinema_id);
        // let payload = {
        //   tableName: "ms_cinemas"
        // };
        MasterService.GetCinemas({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinemas = data.Records;
              this.cinemasCopy = data.Records;
              // this.cinemas.map(x => {
              //   if (String(x.cine_id) == String(cinema_id)) {
              //     this.selectedCinema = x.cine_name;
              //   }
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getConcessionLevels: function(cinema_id, concession_level_id) {
        this.concessionLevels = [];
        this.selectedConcession = "Select Concession";
        // let payload = {
        //   tableName: "ms_concession_levels",
        //   cl_is_active: "Y",
        //   cinema_id: cinema_id
        // };
        MasterService.GetConcessionByCinema({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.concessionLevels = data.Records;
              this.concessionLevels.map((x) => {
                if (x.cl_id == concession_level_id) {
                  this.selectedConcession = x.cl_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getStoreManagementLevel: function(cinema_id, sm_id) {
        this.storeManagementsLevels = [];
        this.selectedStoreLevel = "";
        // let payload = {
        //   tableName: "store_management",
        //   sm_is_active: "Y",
        //   cinema_id: cinema_id
        // };
        MasterService.GetStoreManagement({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.storeManagementsLevels = data.Records;

              this.storeManagementsLevels.map((x) => {
                if (x.sm_id == sm_id) {
                  if (x.sm_parent_id !== 0) {
                    this.selectedFinalStore = x.sm_store_name;
                    this.fnb_wastage.sm_id = sm_id;

                    const mainStore = this.storeManagementsLevels.filter(
                      (y) => {
                        return y.sm_id === x.sm_parent_id;
                      }
                    );
                    //To Solve the Bug When mainStore is Empty
                    if (mainStore.length > 0) {
                      this.selectedStoreLevel = mainStore[0].sm_store_name;
                    } else {
                      this.selectedStoreLevel = x.sm_store_name;
                    }
                  } else {
                    this.selectedStoreLevel = x.sm_store_name;
                    this.fnb_wastage.sm_id = sm_id;
                  }
                  this.onSelectMainStoreLevel(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectCinema: function(cinema) {
        this.selectedCinema = cinema.cine_name;
        this.fnb_wastage.cinema_id = cinema.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.getConcessionLevels(cinema.cine_id);
      },
      onSelectConcessionLevel: function(concession) {
        this.selectedConcession = concession.cl_name;
        this.fnb_wastage.concession_level_id = concession.cl_id;
      },
      calculatemaxqty: function(value) {
        if (value > this.max_qty) {
          this.fnb_wastage.fw_quantity = this.max_qty;
          this.$toasted.show("Max Quantity can be " + this.max_qty);
        } else {
          this.fnb_wastage.fw_quantity = value;
        }
      },
      onSelectMainStoreLevel: function(store) {
        this.selectedStoreLevel = store.sm_store_name;
        this.finalStoreLevel = [];
        this.selectedFinalStore = "";
        this.fnb_wastage.sm_id = null;
        let payload = {
          cine_id: this.fnb_wastage.cinema_id,
          sm_parent_id: store.sm_id,
        };
        MasterService.GetStoreManagement(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.finalStoreLevel = data.Records;
              console.log("this.finalStoreLevel :>> ", this.finalStoreLevel);
            } else {
              this.$toasted.show("No Stores found at Level 2 or Level 3");
              this.fnb_wastage.sm_id = store.sm_id;
              this.getRawMaterials(store);
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },

      onSelectStoreLevel: function(store) {
        this.selectedFinalStore = store.sm_store_name;
        this.fnb_wastage.sm_id = store.sm_id;
        this.getRawMaterials(null, store);
      },

      onSelectRawMaterial: function(rawmaterial) {
        this.selectedRawMaterial = rawmaterial.rm_name;
        this.fnb_wastage.rm_id = rawmaterial.rm_id;
        this.max_qty = rawmaterial.final_stock_quantity;
        this.searchRawMaterial = "";
        this.selectedUoM = "";
        this.fnb_wastage.uom_id = null;
        this.onSearchRawMaterial();
        this.getRelatedUom(rawmaterial.rm_id);
      },

      getRelatedUom: function(rm_id) {
        let cinema_id = this.fnb_wastage.cinema_id;
        PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.UoMList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },

      onSelectUom: function(uom) {
        this.selectedUoM = uom.uom_unit;
        this.fnb_wastage.uom_id = uom.uom_id;
      },

      onSelectAccountableUser: function(user) {
        this.selectedAccountableUser = user.first_name;
        this.fnb_wastage.fw_accountable_user_id = user.user_id;
        this.searchUser = "";
        this.onSearchUser();
      },

      onSelectApprovedByUser: function(user) {
        this.selectedApprovedUser = user.first_name;
        this.fnb_wastage.fw_approved_by = user.user_id;
        this.searchApprovedBy = "";
        this.onSearchApprovedBy();
      },

      onResetForm: function() {
        this.fnb_wastage = {
          cinema_id: "",
          concession_level_id: "",
          sm_id: "",
          rm_id: "",
          fw_quantity: "",
          uom_id: "",
          fw_reason: "",
          // fw_accountable_user_id: "",
          fw_is_approved: "",
          fw_approved_by: "",
          fw_fine_amount: "",
          fw_date: "",
          fw_is_active: true,
        };
        this.selectedCinema = "Select Cinema";
        this.selectedConcession = "Select Concession";
        this.selectedQuantity = "Select Quantity";
        this.selectedUoM = "Select Uom";
      },
      onFinalSubmit: function(flag) {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (
            this.fnb_wastage.cinema_id.length == 0 ||
            this.selectedStoreLevel.length == 0 ||
            (this.selectedStoreLevel.length != 0 &&
              this.selectedFinalStore.length == 0) ||
            this.fnb_wastage.fw_approved_by.length == 0 ||
            this.fnb_wastage.rm_id.length == 0 ||
            this.fnb_wastage.uom_id.length == 0 // ||
            // this.fnb_wastage.fw_accountable_user_id.length == 0
          ) {
            return;
          }
          if (valid) {
            let payload = {
              ...this.fnb_wastage,
            };
            PosFnbService.UpdateFnbWastage(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  this.$router.push({
                    path: "/fnb/fnb-wastage",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/editFnbWastage.vue